import React from 'react';
import { Helmet } from 'react-helmet';

const PrivacyPolicyPage = () => {
    return (
        <>
        <Helmet>
            <title>
                Privacy Policy - microURLs | An URL shortener app
            </title>
        </Helmet>
        <div className="flex items-center justify-center">
            <div className="bg-white shadow-lg rounded-lg m-2 md:m-4 p-6 w-auto">
                <h1 className="text-2xl md:text-4xl font-bold mb-4 text-center">Privacy Policy</h1>

                <p className="text-lg text-justify mb-4">
                    At MicroURLs, we value the privacy of our users and are committed to protecting their personal information.
                    This Privacy Policy outlines how we collect, use, and safeguard the information you provide to us when using our services.
                    By using MicroURLs, you consent to the practices described in this policy.
                </p>

                <h2 className="text-xl font-bold mb-2">Information Collection and Use</h2>

                <p className="text-lg text-justify mb-4">
                    When you use MicroURLs, we may collect certain personally identifiable information from you,
                    including but not limited to your name, email address, and IP address.
                    We use this information to provide and improve our services, respond to your inquiries, and personalize your experience.
                    We do not sell or share your personal information with third parties unless required by law or with your consent.
                </p>

                <h2 className="text-xl font-bold mb-2">Data Security</h2>

                <p className="text-lg text-justify mb-4">
                    We take reasonable precautions to protect the personal information you provide to us from unauthorized access, use, or disclosure.
                    However, please note that no method of transmission over the internet or electronic storage is completely secure,
                    and we cannot guarantee the absolute security of your information.
                </p>

                <h2 className="text-xl font-bold mb-2">Cookies</h2>

                <p className="text-lg text-justify mb-4">
                    MicroURLs uses cookies to enhance your experience and provide personalized content.
                    A cookie is a small text file stored on your device that contains information about your visit to our website.
                    You can disable cookies through your browser settings, but please note that some features of our website may not function properly without cookies.
                </p>

                <h2 className="text-xl font-bold mb-2">Third-Party Links</h2>

                <p className="text-lg text-justify mb-4">
                    MicroURLs may contain links to third-party websites or services that are not owned or controlled by us.
                    We have no control over and assume no responsibility for the content, privacy policies, or practices of any third-party sites or services.
                    We encourage you to review the privacy policies of those third parties before providing any personal information or using their services.
                </p>

                <h2 className="text-xl font-bold mb-2">Changes to This Privacy Policy</h2>

                <p className="text-lg text-justify mb-4">
                    We may update our Privacy Policy from time to time.
                    Any changes we make will be posted on this page, and the revised date will be indicated at the top of the policy.
                    We encourage you to review this Privacy Policy periodically for any changes.
                </p>

                <p className="text-lg text-center font-bold">Effective Date: February 28, 2023</p>
            </div>
        </div>
        </>
    );
};

export default PrivacyPolicyPage;
